/**
 * Fields consumed by {@link addressFormat}.
 * Full domain addresses (`IWorkAddress`, `IAddress`) and partial Elastic/Firestore
 * payloads both satisfy this shape.
 */
export type AddressFormatInput = {
  address?: string | null;
  floorOffice?: string | null;
  commune?: string | null;
  city?: string | null;
  region?: string | null;
  zip?: string | null;
};

/**
 * @description Format address to string standard
 */
export const addressFormat = (address: AddressFormatInput | null | undefined): string => {
  if (!address) return '-';

  const parts: string[] = [];

  const push = (value: string | null | undefined) => {
    const t = value?.trim();
    if (t) parts.push(t);
  };

  push(address.address);
  push(address.floorOffice);

  const commune = address.commune?.trim();
  const city = address.city?.trim();

  if (commune) {
    parts.push(commune);
  }
  if (city && city.toLowerCase() !== commune?.toLowerCase()) {
    parts.push(city);
  }

  push(address.region);
  push(address.zip);

  return parts.join(', ');
};
